import { render, staticRenderFns } from "./ShippingReportTableMobile.vue?vue&type=template&id=6eb4336e&scoped=true"
import script from "./ShippingReportTableMobile.vue?vue&type=script&lang=js"
export * from "./ShippingReportTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb4336e",
  null
  
)

export default component.exports